import { Route, Routes, useNavigate } from "react-router-dom";
import React, { useContext, useEffect } from "react";
import { contextApi, ConfigProvider } from "./context/contextApi";
import "./assets/css/financial-theme.css";
import { Dashboard } from "./pages/Dashboard";
import { SideBar } from "./components/SideBar";
import { Header } from "./components/Header";
import { Beneficiary } from "./pages/Beneficiary";
import { ReceivePayment } from "./pages/ReceivePayment";
import { Reports } from "./pages/Reports";
import { ReciveMoney } from "./pages/ReciveMoney";
import { Gold } from "./pages/Gold";
import { GoldMelted } from "./pages/GoldMelted";
import { GoldCoin } from "./pages/GoldCoin";
import { Cryptocurrency } from "./pages/Cryptocurrency";
import { Help } from "./pages/Help";
import { Support } from "./pages/Support";
import { CreateTicket } from "./pages/CreateTicket";
import { TicketDetail } from "./pages/TicketDetail";
import { WalletCurrency } from "./pages/WalletCurrency";
import { WalletInvestment } from "./pages/WalletInvestment";
import { Wallet } from "./pages/Wallet";
import { WalletInternetGateway } from "./pages/WalletInternetGateway";
import { WalletRialAccount } from "./pages/WalletRialAccount";
import { WalletRialCheck } from "./pages/WalletRialCheck";
import { WalletRialVip } from "./pages/WalletRialVip";
import { WalletCard } from "./pages/WalletCard";
import { Bill } from "./pages/Bill";
import { Convert } from "./pages/Convert";
import { Login } from "./pages/Login";
import Understruction from "./pages/UnderStruction";
import Success from "./pages/Success";
import UnSuccess from "./pages/UnSuccess";
import { PasswordUser } from "./pages/PasswordUser";
import BankPage from "./pages/BankPage";
import axios from "axios";

function App() {
  const context = useContext(contextApi);
  const navigate = useNavigate();

  useEffect(() => {
    if (!context.login && localStorage.getItem("login") == undefined) {
      navigate("/login");
    } else {
      context.setLogin(true);
    }
  }, [context, navigate]);

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const response = await axios.post(
          "https://napi.jibit.ir/ide/v1/tokens/generate",
          { apiKey: "YOUR_API_KEY", secretKey: "YOUR_SECRET_KEY" },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log("Token Response:", response.data);
        localStorage.setItem("accessToken", response.data.accessToken);
      } catch (error) {
        console.error("Error generating token:", error);
      }
    };

    //fetchToken();
  }, []);

  return (
    <div className="col-span-full h-screen">
      <div className="flex flex-row w-full m-auto h-auto lg:h-full">
        {context.login ? (
          <div className="basis-1/5 md:basis-1/3 lg:basis-1/5 parent-side">
            <SideBar />
          </div>
        ) : null}
        <div className="flex flex-col basis-full max-w-full">
          <Header />
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/wallet-gold" element={<Gold />} />
            <Route path="/wallet-gold-melted" element={<GoldMelted />} />
            <Route path="/wallet-gold-coin" element={<GoldCoin />} />
            <Route path="/login" element={<Login />} />
            <Route path="/passwordUser" element={<PasswordUser />} />
            <Route path="/bankpage" element={<BankPage />} />
            <Route path="/wallet-rial-pos" element={<Wallet />} />
            <Route
              path="/wallet-internet-gateway"
              element={<WalletInternetGateway />}
            />
            <Route
              path="/wallet-rial-account"
              element={<WalletRialAccount />}
            />
            <Route path="/wallet-rial-check" element={<WalletRialCheck />} />
            <Route path="/wallet-rial-vip" element={<WalletRialVip />} />
            <Route path="/wallet-card" element={<WalletCard />} />
            <Route path="/wallet-tether" element={<Cryptocurrency />} />
            <Route path="/ReceivePayment" element={<ReceivePayment />} />
            <Route path="/success" element={<Success />} />
            <Route path="/un-success" element={<UnSuccess />} />
            <Route path="/Beneficiary" element={<Beneficiary />} />
            <Route path="/recivePayment" element={<Understruction />} />
            <Route path="/wallet-curency" element={<WalletCurrency />} />
            <Route path="/wallet-investment" element={<WalletInvestment />} />
            <Route path="/Reports" element={<Reports />} />
            <Route path="/ReciveMoney" element={<ReciveMoney />} />
            <Route path="/help" element={<Help />} />
            <Route path="/Bill" element={<Bill />} />
            <Route path="/convert" element={<Convert />} />
            <Route path="/support" element={<Support />} />
            <Route path="/support/create" element={<CreateTicket />} />
            <Route path="/support/:id" element={<TicketDetail />} />
            <Route
              path="*"
              element={
                <div>
                  <h2>404 Page not found</h2>
                </div>
              }
            />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default function AppWrapper() {
  return (
    <ConfigProvider>
      <App />
    </ConfigProvider>
  );
}
